export default "__VITE_ASSET__bed02b24__"